import { useGetCalendarV3QueriesData } from '../hooks';

// Safe wrapper to use calendar v3 data when available
const useSafeCalendarV3Data = () => {
  try {
    return useGetCalendarV3QueriesData();
  } catch (error) {
    return { appointmentTypesData: null, providersData: null };
  }
};

// @TODO: Fetching provider and appointment type details as a workaround to get their archive status,
// which needs to be removed once we get these details from the API
export const useGetEntityArchiveStatus = ({
  appointmentTypeId,
  providerId,
}: {
  appointmentTypeId: string;
  providerId: string;
}) => {
  // This context is not available from v2 calendar
  const { appointmentTypesData, providersData } = useSafeCalendarV3Data();

  const appointmentType = appointmentTypesData?.appointmentTypes?.find((type) => type.id === appointmentTypeId);
  const isAppointmentTypeArchived =
    appointmentType?.details?.act === undefined ? false : !appointmentType?.details?.act;

  const provider = providersData?.providers?.find((provider) => provider.id === providerId);
  const isProviderArchived = !!provider?.isArchived;

  return {
    isAppointmentTypeArchived,
    isProviderArchived,
  };
};
